import { createFileRoute, Outlet } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { SectionNav, type SectionNavItem } from "@/components/section-nav";
import { useEmailConfigured } from "@/lib/kindle";

/** Layout of the personal settings area with its sub-navigation. */
export const Route = createFileRoute("/_app/settings")({
  component: SettingsLayout,
});

export function SettingsLayout() {
  const { t } = useTranslation("settings");
  const emailConfigured = useEmailConfigured();
  const items: SectionNavItem[] = [
    { to: "/settings/account", label: t("area.account") },
    { to: "/settings/devices", label: t("area.devices") },
    ...(emailConfigured ? [{ to: "/settings/kindle" as const, label: t("area.kindle") }] : []),
  ];
  return (
    <div className="grid gap-6 md:grid-cols-[12rem_minmax(0,1fr)] md:gap-8">
      <SectionNav variant="sidebar" label={t("area.label")} items={items} />
      <div className="min-w-0">
        <Outlet />
      </div>
    </div>
  );
}
